<template>
  <div
    v-show="visible"
    class="chat-widget-dropdown"
  >
    <label
      v-if="label"
      class="chat-widget-dropdown__label"
    >
      {{ label }}
    </label>
    <select
      class="chat-widget-dropdown__select form-control form-control-sm"
      :disabled="disabled"
      :value="selectedValue"
      @change="onSelect($event.target.value)"
    >
      <option
        v-if="placeholder"
        value=""
        disabled
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetDropdown',
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedValue: this.value || (this.options.length ? this.options[0].value : ''),
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    onSelect(value) {
      this.selectedValue = value;
      this.$emit('select', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-widget-dropdown {
  &__label {
    display: block;
    font-size: 12px;
    color: #64748b;
    margin-bottom: 4px;
  }

  &__select {
    font-size: 13px;
    border-color: #e2e8f0;
    border-radius: 6px;

    &:focus {
      border-color: #379C75;
      box-shadow: 0 0 0 0.2rem rgba(55, 156, 117, 0.25);
    }
  }
}
</style>
